// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"16":"select-avatar","86":"main-menu","238":"testing","774":"select-language"}[chunkId] || chunkId) + "." + {"16":"059f8702","86":"c00885fb","238":"d4866dd8","709":"8dfe8450","774":"37cda5cc"}[chunkId] + ".css";
};